import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { parse } from "date-fns";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { jsPDF } from "jspdf";
import {
  openSessionModal,
  fetchSingleSessionAssociatedUsers,
  fetchSingleSessionRSVPUsers,
  deleteSchedule,
  updateSessionFiles,
  downloadSessionPdf,
  fetchSessionQr,
} from "ContentActions";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  MAIN_URL,
  BASE_IMAGES_URL,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import { HEIGHT_PER_HOUR } from "ScheduleConstants";
import LocaleStrings from "Languages";

class ScheduleItem extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };

    this.myRef = React.createRef();
  }

  onEditSessionClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var { schedule } = this.props;
    var fileName1 = "";
    var fileName2 = "";
    var fileName3 = "";
    var fileName4 = "";
    var fileName5 = "";

    if (schedule.file1) {
      var f1 = schedule.file1.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName1 = f2 + "." + ext;
    }
    if (schedule.file2) {
      var f1 = schedule.file2.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName2 = f2 + "." + ext;
    }
    if (schedule.file3) {
      var f1 = schedule.file3.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName3 = f2 + "." + ext;
    }
    if (schedule.file4) {
      var f1 = schedule.file4.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName4 = f2 + "." + ext;
    }
    if (schedule.file5) {
      var f1 = schedule.file5.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName5 = f2 + "." + ext;
    }
    var files = [
      {
        position: "file1",
        file: schedule.file1 ? schedule.file1 : "",
        filename: fileName1,
      },
      {
        position: "file2",
        file: schedule.file2 ? schedule.file2 : "",
        filename: fileName2,
      },
      {
        position: "file3",
        file: schedule.file3 ? schedule.file3 : "",
        filename: fileName3,
      },
      {
        position: "file4",
        file: schedule.file4 ? schedule.file4 : "",
        filename: fileName4,
      },
      {
        position: "file5",
        file: schedule.file5 ? schedule.file5 : "",
        filename: fileName5,
      },
    ];

    this.props.fetchSingleSessionAssociatedUsers(
      this.props.session,
      schedule,
      (res) => {}
    );
    this.props.fetchSingleSessionRSVPUsers(
      this.props.session,
      schedule,
      (res) => {}
    );
    this.props.updateSessionFiles(files); // store files details locally
    this.props.openSessionModal({ status: true, session: schedule });
  }

  onDeleteSessionClick(e) {
    e.preventDefault();
    e.stopPropagation();
    // console.log("element :- ", e);

    confirmAlert({
      title: LocaleStrings.content_delete,
      message: LocaleStrings.schedule_delete_message,
      confirmLabel: LocaleStrings.content_ok,
      cancelLabel: LocaleStrings.content_cancel,
      buttons: [
        {
          label: LocaleStrings.content_ok,
          onClick: () => {
            this.props.deleteSchedule(
              this.props.session,
              {
                ...this.props.schedule,
                scheduledateid: this.props.selectedScheduleDate.scheduledateid,
              },
              (result) => {
                if (result.error) {
                  this.props.showError(LocaleStrings.schedule_delete_failed);
                } else {
                  this.props.showSuccess(
                    LocaleStrings.schedule_successfully_deleted
                  );
                  this.props.checkContentDashboardStatus(this.props.session);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.content_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  downloadPdfF = (e, values) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("element :- ", e);
    let { session, eventDetails } = this.props;
    // console.log("session :- ", session);
    // console.log("values :- ", values);
    // console.log("eventDetails :- ", eventDetails);

    // this.setState({ loading: true });
    // this.props.downloadSessionPdf(values.sessionid, (response) => {
    //   if (response.success) {
    //     var pdfurl = response.message.pdf;
    //     var filename = values.title;
    //     // console.log("filename", filename);
    //     // var uri = `${MAIN_URL}/pdfgenerate/sessionqr.pdf`;
    //     var uri = `${MAIN_URL}/${pdfurl}`;

    //     //this trick will generate a temp <a /> tag
    //     var link = document.createElement("a");
    //     link.href = uri;

    //     //set the visibility hidden so it will not effect on your web-layout
    //     link.style = "visibility:hidden";
    //     link.download = filename;
    //     link.target = "_blank";

    //     //this part will append the anchor tag and remove it after automatic click
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   } else {
    //     this.props.showError(COMMON_FAIL_MESSAGE);
    //     this.setState({ loading: false });
    //   }
    // });

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.schedule_sessionqr_download_title}</h1>
            <p>{LocaleStrings.schedule_sessionqr_download_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.fetchSessionQr(
                    session,
                    { sessionid: values.sessionid, eventid: values.eventid },
                    (response) => {
                      onClose();
                      // console.log("response", response);
                      if (response.success === 0) {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else {
                        let qrString = response.data.qr;

                        let themecolor = eventDetails.themecolor;
                        let eventname = eventDetails.eventname;
                        let imgData = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
                        let date = values.starttime
                          ? moment(values.starttime).format(
                              DISPLAY_LOCAL_DATE_FORMAT
                            )
                          : "";
                        let stime = values.starttime
                          ? moment(values.starttime).format("hh:mm A")
                          : "";
                        let etime = values.endtime
                          ? moment(values.endtime).format("hh:mm A")
                          : "";

                        const doc = new jsPDF("p", "pt", [8.3 * 72, 11.7 * 72]);
                        let getPageWidth =
                          doc.internal.pageSize.width ||
                          doc.internal.pageSize.getWidth();

                        doc.setFillColor(`${themecolor}`);
                        doc.rect(0, 0, 8.3 * 72, 66, "F");

                        doc.setFontSize(20);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Session Check-in`, 37, 20 + 20);

                        let titleFont = values.title.length < 86 ? 26 : 24;

                        doc.setFontSize(titleFont);
                        doc.setFont(`Helvetica`, `normal`, `700`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${values.title}`, 37, 80 + titleFont, {
                          maxWidth: getPageWidth - 70,
                        });

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`Date  :  ${date}`, 37, 170 + 17);

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`Time  :  ${stime} - ${etime}`, 37, 196 + 17);

                        doc.setFillColor(`#000000`);
                        doc.roundedRect(100, 249, 395, 437, 10, 10, "F");

                        doc.addImage(qrString, "JPEG", 110, 259, 375, 347);

                        doc.setFontSize(36);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#fff`);
                        doc.text(`Scan Me`, 225, 620 + 36);

                        doc.addImage(imgData, "JPEG", 274, 708, 50, 50);

                        doc.setFontSize(17);
                        doc.setFont(`Helvetica`, `normal`, `400`);
                        doc.setTextColor(`#000000`);
                        doc.text(`${eventname}`, getPageWidth / 2, 760 + 17, {
                          align: "center",
                          maxWidth: getPageWidth,
                        });

                        doc.save(`${values.title}.pdf`);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  renderSupportingSpeakers() {
    let total =
      this.props.supportingspeakers.length > 1
        ? `+ ${this.props.supportingspeakers.length - 1}`
        : "";

    let items = `${this.props.supportingspeakers[0].firstname} ${this.props.supportingspeakers[0].lastname} ${total}`;

    return items;
  }

  render() {
    let { schedule, layout, eventDetails } = this.props;
    var nowStart = parse(
      moment(this.props.schedule.starttime).format("DD-MM-YYYY HH:mm:ss"),
      "dd-MM-yyyy HH:mm:ss",
      new Date()
    );

    var nowEnd = parse(
      moment(this.props.schedule.endtime).format("DD-MM-YYYY HH:mm:ss"),
      "dd-MM-yyyy HH:mm:ss",
      new Date()
    );

    let sessionStartTime = moment(nowStart.getTime()).format("HH:mm");
    let sessionEndTime = moment(nowEnd.getTime()).format("HH:mm");

    if (eventDetails.eventid === 1788814323020083) {
      sessionStartTime = moment(nowStart.getTime()).format("hh:mm A");
      sessionEndTime = moment(nowEnd.getTime()).format("hh:mm A");
    }

    var csscolor = this.props.sessioncolor;
    var bgcolor = csscolor.backgroundcolor;
    var maincolor = csscolor.primarytextcolor;
    var subcolor = csscolor.secondarytextcolor;
    var bordercolor = csscolor.bordercolor;

    var mainDivStyle = {
      border: "1px",
      borderStyle: "solid",
      borderRadius: "2px",
      margin: "0px 10px 0px 10px",
      padding: "5px",
      position: "absolute",
      backgroundColor: bgcolor,
      borderColor: bordercolor,
      width: "180px",
      height: `${layout.height}px`,
      top: `${layout.top}px`,
      left: `${layout.left}px`,
    };

    var scheduleTitleStyle = {
      color: maincolor,
    };

    var scheduleSubTitleStyle = {
      color: subcolor,
      fontSize: "10px",
    };

    var roomStyle = {
      color: subcolor,
      fontSize: "10px",
    };

    var speakers = "";
    if (
      !_.isEmpty(this.props.speaker) &&
      !_.isEmpty(this.props.supportingspeakers)
    ) {
      speakers = (
        <>
          {`${this.props.speaker.firstname} ${this.props.speaker.lastname} + ${this.props.supportingspeakers.length}`}
        </>
      );
    } else if (!_.isEmpty(this.props.speaker)) {
      speakers = (
        <>
          {this.props.speaker.firstname} {this.props.speaker.lastname}
        </>
      );
    } else if (!_.isEmpty(this.props.supportingspeakers)) {
      speakers = <>{this.renderSupportingSpeakers()}</>;
    }

    if (this.props.isFetching) {
      return <div />;
    }
    // console.log('schedule:--->', this.props.schedule)

    return (
      <div
        style={mainDivStyle}
        className="session-item"
        onClick={this.onEditSessionClick.bind(this)}
      >
        <div>
          <div
            className="session-delete"
            style={{ backgroundColor: maincolor }}
          >
            <div
              className="session-delete-icon"
              style={{
                borderBottom: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: bgcolor,
              }}
              onClick={this.onEditSessionClick.bind(this)}
            >
              <img src="../../style/images/edit-icon-small-white.png" />
            </div>
            <div
              className="session-delete-icon"
              onClick={this.onDeleteSessionClick.bind(this)}
              style={{
                borderBottom: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: bgcolor,
              }}
            >
              <img
                style={{ marginLeft: "8px" }}
                src="../../style/images/delete-icon-white.png"
              />
            </div>
            {this.props.schedule.checkintype == "scanqr" ||
            this.props.schedule.checkintype == "bothside" ? (
              <div
                className="session-delete-icon"
                onClick={(e) => this.downloadPdfF(e, this.props.schedule)}
              >
                <div style={{ backgroundColor: maincolor }}>
                  <span className="session-toolitp-btn">
                    <i
                      className="fa fa-download"
                      style={{ color: "#fff", paddingLeft: "5px" }}
                    />
                    <span className="session-tooltiptext">
                      Download Session QR
                    </span>
                  </span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="schedule-title-text" style={scheduleTitleStyle}>
          {this.props.schedule.title}
        </div>

        {speakers ? (
          <div
            className="schedule-speakers-container"
            style={scheduleSubTitleStyle}
          >
            <i className="fa-solid fa-microphone me-1"></i>
            {speakers}
          </div>
        ) : (
          ""
        )}

        {schedule.location ? (
          <div className="schedule-location-container" style={roomStyle}>
            <i className="fa-regular fa-location-dot me-1"></i>

            {this.props.schedule.location}
          </div>
        ) : (
          ""
        )}

        {sessionStartTime !== "" && sessionEndTime !== "" ? (
          <div className="schedule-location-container" style={roomStyle}>
            <i className="fa fa-clock-o me-1" aria-hidden="true"></i>
            {sessionStartTime} - {sessionEndTime}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var speaker = {};
  var supportingspeakers = [];

  if (state.scheduleData.payload.speaker_by_eventid) {
    speaker = state.scheduleData.payload.speaker_by_eventid.filter(
      (speaker) => speaker.speakerid === ownProps.schedule.speakerid
    )[0];
    //debugger;
    state.scheduleData.payload.speaker_by_eventid.filter((speaker) => {
      state.scheduleData.payload.sessionspeakers_by_eventid.map(
        (sessionspeaker) => {
          if (
            sessionspeaker.speakerid === speaker.speakerid &&
            ownProps.schedule.sessionid === sessionspeaker.sessionid
          )
            supportingspeakers.push(speaker);
        }
      );
    });
  }

  var sessioncolor = {};
  if (state.sessionColors.payload) {
    sessioncolor = state.sessionColors.payload.filter(
      (color) => color.colorid === ownProps.schedule.colorid
    )[0];
  }
  return {
    session: state.session,
    speaker,
    supportingspeakers,
    sessioncolor,
    isFetching: state.scheduleData.isFetching,
    selectedScheduleDate: state.selectedScheduleDate,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openSessionModal,
  fetchSingleSessionAssociatedUsers,
  fetchSingleSessionRSVPUsers,
  deleteSchedule,
  checkContentDashboardStatus,
  updateSessionFiles,
  downloadSessionPdf,
  fetchSessionQr,
})(ScheduleItem);
